import { IAiDataExtractorUploadInput } from '../components/features/Login/interface/interface';
import { IActions, IAiDataExtractorUploadedFiles, IBasicDetails, ICategoryButtons, INodeWithPath, ITreeNode } from '../interface/interfaces';
import { camelCaseToWords } from '../utils/camelCaseToWord';

export const USER_AND_TOKEN = 'userAndToken';
export const PROJECT = 'project';
export const STAGING_ID = 'stagingId';
export const PROJECT_NODE = 'projectNode';
export const DELETED_STAGED_AVATAR_ID = 'deletedStagedAvatarId';
export const MODAL = 'modal';
export const CHAT_BOT_HISTORY = 'chatBotHistory';
export const WEBSOCKET_HOSTNAME = 'websocketHostname'
export const SAVED_USER_TOKEN = 'savedUserToken'
export const USER_SETTINGS_ALL_PATHS = 'userSettingsAllPaths'
export const PROJECT_CONFIG_FEATURE_LIST = 'projectConfigFeatureList'

export const enum Methods {
    GET = 'get',
    POST = 'post',
    PUT = 'put',
    DELETE = 'delete',
}
export const enum Roles {
    ADMINISTRATOR = 'Admin',
}


export const Avatars = {
    AvatarProject: 'AvatarProject',
    AvatarAnlage: 'AvatarAnlage',
    AvatarSPS: 'AvatarSPS',
    AvatarSchutzkreis: 'AvatarSchutzkreis',
    AvatarStation: 'AvatarStation',
    AvatarRobot: 'AvatarRobot',
    AvatarGripper: 'AvatarGripper',
    AvatarTool: 'AvatarTool',
    AvatarGeneric: 'AvatarGeneric',
    AvatarAny: 'AvatarAny',
} as const;


export const AvatarsFormatted = {
    Project: camelCaseToWords(Avatars.AvatarProject),
    Anlage: camelCaseToWords(Avatars.AvatarAnlage),
    SPS: camelCaseToWords(Avatars.AvatarSPS),
    Station: camelCaseToWords(Avatars.AvatarStation),
    Schutzkreis: camelCaseToWords(Avatars.AvatarSchutzkreis),
    Robot: camelCaseToWords(Avatars.AvatarRobot),
    Gripper: camelCaseToWords(Avatars.AvatarGripper),
    Tool: camelCaseToWords(Avatars.AvatarTool),
    Generic: camelCaseToWords(Avatars.AvatarGeneric),
    Any:camelCaseToWords(Avatars.AvatarAny)
} as const;

// export const avatarHierarchy = [Avatars.AvatarProject, Avatars.AvatarAnlage, Avatars.AvatarSPS, Avatars.AvatarSchutzkreis, Avatars.AvatarStation, Avatars.AvatarRobot, Avatars.AvatarGripper, Avatars.AvatarTool];
// Avatars hierarchy
export const avatarHierarchy = Object.keys(Avatars).filter(
    avatar => avatar !== 'AvatarAny'
);

export type SelectedTreeNodeKeys = keyof Pick<
    ITreeNode,
    Exclude<keyof ITreeNode, 'ParentNode' | 'ChildNodes' | 'All'>
    // 'AllAnlage' | 'AllSPS' | 'AllStation' | 'AllSchutzkreis' | 'AllRobot' | 'AllGripper' | 'AllTool' | 'AvatarGeneric' | 'AllAny'
>;


export interface ICombo {
    CONFLICT_CATEGORY: string[];
    PRIORITY: string[];
}

export const ComboSelect: ICombo = {
    CONFLICT_CATEGORY: ['Weld points', 'Missing parts', 'I/O Signals', 'Version Conflicts', 'Position Conflict'],
    PRIORITY: ['HIGH', 'LOW'],
};

// export const CONFLICT_CATEGORY: string[] = ['Weld points', 'Missing parts', 'I/O Signals', 'Version Conflicts', 'Position Conflict'];
// export const PRIORITY: string[] = ["HIGH", "LOW"]

export const enum Queries {
    PROJECT_ID = 'projectId',
}

// export const USERNAMES_DEV = ['jovica.cvetkovic', 'steineke_sync.user']
export const USERNAMES_DEV = process.env.REACT_APP_PROTECTED_USERS?.split(',') || [];
export const PROJECT_ADMIN = process.env.REACT_APP_PROTECTED_PROJECT_ADMIN?.split(',') || [];

export const FLOW_KEY = 'flow_key';
export const PAN_ON_DRAG = [1, 2];

export const CONFLICT_INSPECTOR_BUTTONS: ICategoryButtons[] = [
    {
        iconName: 'Datamanager',
        label: 'Actions',
    },
    {
        iconName: 'Category',
        label: 'Conflicts',
    },
    {
        iconName: 'Details',
        label: 'Details',
    },
    {
        iconName: 'Neuland_AI',
        label: 'AI Analyzer',
    },
];

export const DASHBOARD_CONFIG_BUTTONS: ICategoryButtons[] = [
    {
        iconName: 'Overview',
        label: 'Overview',
    },
    {
        iconName: 'Configuration',
        label: 'Configuration',
    },
    {
        iconName: 'Files',
        label: 'Files',
    }
]

export const EXCLUDE_AVATARS = ['Project'];

export const INITIAL_ACTION: IActions = {
    Parameter: '',
    Label: '',
    Description: '',
    Commiting: false,
    GroupName: '',
    TargetDepartmentId: -1,
};


export enum DataManagerSections {
    FOLDER_STRUCTURE = 'Folder Structure',
    SENDING_DATA = 'Sending Data',
    FILE_MANAGEMENT = 'File Management',
}

export enum WEBSOCKET_PARAMETERS{
    USER_SETTINGS_HOSTNAME = 'User settings hostname',
    USER_SETTINGS_FILE_PATH = 'User settings file path'
}


export enum ROUTES{
    PROJECTS = 'projects',
    PROJECT = 'project',
    CONFIGURATION = 'project-configuration',
    DASHBOARD = 'dashboard',
    FEATURES = 'features',
    DATAMANAGER = 'datamanager',
    QGATE = 'qgate',
    TESTING_AREA = 'testing-area',
    PROJECT_ADMIN_COFIGURATION = 'project-admin-configuration',
    DASHBOARD_STATUS = 'dashboard-status',
    GIT_VERSION = 'git-version',
    DATA_ORGANIZER = 'data-organizer',
    AI_DATA_EXTRACTOR = 'ai-data-extractor-packages'
}

export const headerItems = ['Icon', 'Title', 'Type', 'File name', 'Uploader', 'Origin', 'Description', 'Size', 'U', 'M', 'D', 'V', 'Status'];
export const detailsFilesTableHeader = ['Icon', 'File', 'M', 'D', 'V', 'U', 'S']

// AI DATA EXTRACTOR

export const aiDataExtractorUploadedFilesDefault: IAiDataExtractorUploadedFiles = {
    id: "0",
    title: "",
    type: "",
    filename: "",
    uploader: "",
    origin: "",
    description: "",
    size: 0,
    uploadFrontend: false,
    metadataExtraction: false,
    duplicateChecking: 'no',
    versionChecking: false,
    uploadSharepoint: false,
    status: false,

}

